import React from 'react'

const HomeHeroLogo = props => {
  return (
    <svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 135 290">
      <rect width="135" height="290"/>
      <polygon points="20 75 20 23 39 23 39 56 58 56 58 25 77 25 77 56 96 56 96 23 116 23 116 75 20 75"/>
      <polygon points="20 107.17 20 88 115.86 112 116 112 116 131.04 115.86 131.18 20 155.18 20 136 77.66 121.52 20 107.17"/>
      <rect x="20" y="172" width="96" height="19"/>
      <polygon points="58 229 20 229 20 210 115 210 115 229 77 229 77 248 116 248 116 267 20 267 20 248 58 248 58 229"/>
    </svg>
  )
}

export default HomeHeroLogo


// WEBPACK FOOTER //
// ./src/assets/icons/home-hero-logo.js